@@ -0,0 +1,32 @@
<template>
  <div class="flex justify-center items-center p-10">
    <h2 class="text-center">Loading...</h2>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    if (this.$route.query.procedimiento && this.$route.query.tipo) {
      const procedimiento = this.$route.query.procedimiento;
      const tipo = this.$route.query.tipo;
      switch (procedimiento) {
        case "radicacion":
          switch (tipo) {
            case "conciliacion":
            case "demanda":
              const user = this.session.user;
              let urlToRedirect = "/";
              if (user) {
                urlToRedirect = `/customer/complaint/registration?tipo=${tipo}`;
              } else {
                urlToRedirect = `/login?redireccion=sfc&procedimiento=${procedimiento}&tipo=${tipo}`;
              }
              this.$router.push(urlToRedirect).catch(() => {});
              break;
            default:
              this.$router.push("/").catch(() => {});
              break;
          }
          break;

        default:
          this.$router.push("/").catch(() => {});
          break;
      }
    } else {
      this.$router.push("/").catch(() => {});
    }
  },
  computed: {
    session: function () {
      return this.$store.state.session;
    },
  },
};
</script>
